import { type PropsWithChildren } from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export function Footer({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={twMerge(
        clsx("min-h-[64px] w-full bg-v2-secondary", "p-4 rounded-b-[11px]"),
        className,
      )}
    >
      {children}
    </div>
  );
}
